import {
  signOut,
  sendPasswordResetEmail,
  onAuthStateChanged,
  User,
  updateProfile
} from 'firebase/auth';
import { auth } from '../config/firebase/firebaseConfig';

class FirebaseAuthBackend {
  constructor() {
    onAuthStateChanged(auth, (user: User | null) => {
      if (user) {
        const userData = {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          emailVerified: user.emailVerified
        };
        localStorage.setItem("authUser", JSON.stringify(userData));
      } else {
        localStorage.removeItem("authUser");
      }
    });
  }

  forgetPassword = async (email: string) => {
    try {
      await sendPasswordResetEmail(auth, email, {
        url: window.location.protocol + "//" + window.location.host + "/login",
      });
      return true;
    } catch (error: any) {
      throw this._handleError(error);
    }
  };

  logout = async () => {
    try {
      await signOut(auth);
      return true;
    } catch (error: any) {
      throw this._handleError(error);
    }
  };

   editProfileAPI = async (username: string, idx?: any) => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      try {
        await updateProfile(currentUser, {
          displayName: username
        });
        return { username: currentUser.displayName };
      } catch (error) {
        throw error;
      }
    } else {
      throw new Error('User not authenticated');
    }
  };

  getAuthenticatedUser = () => {
    if (!localStorage.getItem("authUser")) return null;
    return JSON.parse(localStorage.getItem("authUser") || "");
  };

  _handleError(error: any) {
    return error.message;
  }
}

let _fireBaseBackend: FirebaseAuthBackend | null = null;


const getFirebaseBackend = () => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend();
  }
  return _fireBaseBackend;
};

export { getFirebaseBackend };